/**
 * Track run sample
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type TrackRunSample = {
	sampleDuration?: number;
	sampleSize?: number;
	sampleFlags?: number;
	sampleCompositionTimeOffset?: number;
};
